<template>
  <v-app dark>
    <Toolbar/>
    <v-content id="content">
      <div class="btn btn-outline-success float-right" @click="installer()" :style="{'display' : installBtn}">Install</div>
      <Scoreboard v-show="!this.$store.state.game.game_over"/>
      <VictoryScreen v-show="this.$store.state.game.game_over"/>
    </v-content>
  </v-app>
</template>

<script>
import Toolbar from './components/Toolbar'
import Scoreboard from './components/Scoreboard'
import VictoryScreen from './components/VictoryScreen'

export default {
  data: () => ({
    installBtn: 'none',
    installer: undefined
  }),
  mounted () {
    // this.$store.state.game.game_over = false
  },
  created () {
    let installPrompt

    window.addEventListener('beforeinstallprompt', e => {
      e.preventDefault()
      installPrompt = e
      this.installBtn = 'block'
    })

    this.installer = () => {
      this.installBtn = 'none'
      installPrompt.prompt()
      installPrompt.userChoice.then(result => {
        if (result.outcome === 'accepted') {
          console.log('User accepted')
        } else {
          console.log('User declined')
        }
        installPrompt = null
      })
    }
  },
  components: {
    Toolbar,
    Scoreboard,
    VictoryScreen
  }
}
</script>
